<div class="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
  <div class="ps-3">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb mb-0 p-0">
        <li class="breadcrumb-item"><a href="javascript:;"><i class="bx bx-home-alt"></i></a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">CHANNELS</li>
      </ol>
    </nav>
  </div>
</div>
<div class="card">
  <div class="card-body">
    <div class="d-flex">
      <div class="me-auto p-2">
          <div class="form-group d-flex gap-2">
              <select class="form-select" [(ngModel)]="selServerId" (change)="onSelServer()">
                  <option *ngFor="let server of servers" [value]="server.server_name"> {{ server.server_name }}</option>
              </select>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" value="" id="modeCheck" [checked]="selServerMode" (change)="onTestCheck($event)">
                <label class="form-check-label" for="modeCheck">
                  Test Mode
                </label>
              </div>
          </div>
      </div>
      <div class="ms-auto p-2">
          <button class="btn btn-primary btn-sm m-1 ps-0" (click)="loadDetails()">
              <span class="btn-label">
                  <i class="bi bi-arrow-repeat"></i>
                  Refresh
              </span>
          </button>
      </div>
  </div>
  <div class="table-responsive mt-3">
      <table class="table align-middle">
        <thead class="table-secondary">
          <tr>
            <th>BROKER</th>
            <th>LOGIN</th>
            <th>CONNECTION</th>
            <th>LAST UPDATED</th>
            <th>ACTIONS</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor = "let channel of channels">
            <td>{{channel.broker_name}}/{{channel.client_id}}</td>
            <td>{{channel.login_status}}</td>
            <td>{{channel.channel_status}}</td>
            <td>{{channel.last_updated}}</td>
            <td>
              <i class="bi p-2 fs-5" [ngClass]="channelClass(channel)" (click)="onStartStopChannel(channel)"></i>
              <i class="bi bi-arrow-down-up text-primary fs-5" (click)="onSwitchChannel(channel)"></i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
